import type { RefObject } from "react"
import { createContext } from "react"
import type { UserAuthCookie } from "src/types"

export type AuthContextValue = {
  authCookie: UserAuthCookie | null;
  authCookieRef: RefObject<UserAuthCookie | null>;
  baseURL: string | null;
  isAuthenticated: boolean;
  isExpired: boolean;
  isRefreshing: boolean;
  isRefreshingRef: RefObject<boolean>;
  // this is called on sign in
  setAuthCookie: (v: UserAuthCookie, baseURL: string) => void;
  // this is called when initiating or finishing refresh
  setIsRefreshing: (v: boolean) => void;
  // this is called on refresh completed
  refreshAuthCookie: (v: UserAuthCookie) => void;
  // this is called on sign out
  clearAuthCookie: () => void;
}

type ContextType = AuthContextValue | null

export const AuthContext = createContext<ContextType>(null)
